import './css/SuperUserPageView.css';

import * as React from 'react';
import {connect} from 'react-redux';
import {DropdownMenu} from '../DropdownMenu';
import Tabs from "../Tabs/Tabs";
import Tab from "../Tabs/Tab";
import SuperUserOrdersTable from '../SuperUser/components/SuperUserOrdersTable';
import DocumentsTable from '../Home/components/DocumentsTable';
import ManageImages from "./components/ManageImages";
import ManageText from "./components/ManageText";
import ProductsTable from "./components/ProductsTable";
import SeedsTable from "./components/SeedsTable";
import {openDocumentById, deleteProduct, toggleProductPublish, getSeedCategories, cloneDocument} from '../../actions/actions';
import {changeOrderStatus, getAdminOrdersList, deleteOrder, getOrderTypeCount} from '../../actions/orderActions';
import { getProductLogosList, getProductIconsList } from '../../actions/imageActions';
import DeleteConfirmModal from '../Modals/DeleteConfirmModal';
import ShippingModal from '../Modals/ShippingModal/ShippingModal';
import CloneDocumentModal from '../Modals/ClonedDocumentModal/CloneDocumentModal';
import SuccessModal from '../../components/Modals/SuccessModal';
import WarningModal from '../Modals/WarningModal/WarningModal';
import ShippingInfoWarningModal from '../Modals/ShippingInfoWarningModal';
import PDFDownloadModal from '../Modals/PDFDownloadModal/PDFDownloadModal';

import {
    IDivider,
    IDocument,
    IEditorState,
    IUserData,
    IUserDownloadList,
    IOrder,
    IOrderStatus,
    IProduct,
    IProductLogo,   
    IProductIcon,
    ICreateProductState,
    IState,
    IDisclaimer,
    ISeedProduct,
    ISeedProductSubmit,
    ISeedCategory,
    IOrderQuantities_Addresses,
} from "../../infrastructure/interfaces";
import {
    deleteDocument,
    downloadPdf,
    getAllProducts,
    getSeeds,
    getDocumentList,
    getStatesList,
    startLoading,
    stopLoading,
    saveProduct,
    saveSeedProduct,
} from '../../actions/actions';
import DocumentService from '../../services/DocumentService';
import { placeOrder, hideOrderModal } from '../../actions/orderActions';
import DivisionCostTable from './components/DivisionCostTable';
import BatchDownloads from '../BatchDownloads/BatchDownloads';

export interface ISuperUserPageProps {
    adminOrderTypeCount: number;
    adminOrdersList: IOrder[];
    documentList: any[];
    userDownloadList: IUserDownloadList[];
    userData: IUserData;
    orderCreated: boolean;
    orderStatuses: IOrderStatus[];
    productList: [any];
    seedList: ISeedProduct[];
    seedCategories: ISeedCategory[];
    documentInProgress: IDocument | null;
    editor: IEditorState;
    productLogosList: [IProductLogo];
    productIconsList: [IProductIcon];
    createProductState: ICreateProductState;
    statesList: IState[];
    dividers: IDivider[];
    disclaimers: IDisclaimer[];

    getAllProducts(): void;

    getSeeds(): void;

    getSeedCategories(): void;

    getDocumentList(userID: string): void;

    openDocumentById(id: number, redirect?: string): any;

    downloadPdf(document: IDocument): void;

    getAdminOrdersList(startIndex: Number, listSize: Number, orderCategory: Number): void;

    getStatesList(): void;

    deleteOrder(order: IOrder): void;

    getOrderTypeCount(status_id: number): void;

    deleteProduct(product: IProduct): void;

    toggleProductPublish(product: IProduct, published: boolean): void;

    changeOrderStatus(order: any, statudId: number): any;
    
    getProductLogosList(): void;

    getProductIconsList(): void;

    startLoading(): void;

    stopLoading(): void;

    saveProduct(originalName: string,
        product: IProduct,
        imagesFormData?: FormData,
        logoFormData?: FormData): void;

    saveSeedProduct(seed: ISeedProductSubmit): void;

    deleteDocument(id: number): void;

    onDownload(document: IDocument, dividers: IDivider[], disclaimers: IDisclaimer[], userData: IUserData, isPrintDownload: boolean): void;

    placeOrder(document: IDocument, user_id: string, user_email: string, username: string, comments: string, orderQuantitiesAddresses: IOrderQuantities_Addresses[]): void;

    onCloneDocument(document: IDocument, name: string, user_id: string): void;

    hideOrderModal(): void;
}

export interface ISuperUserPageState {
    currentTab: number;
    disclaimers: IDisclaimer[];
    showDeleteDocumentModal: boolean;
    showDeleteOrderModal: boolean;
    showDeleteProductModal: boolean;
    showTogglePublishModal: boolean;
    showDeleteEditingDocumentModal: boolean;
    showShippingInfoWarningModal: boolean;
    showShippingModal: boolean;
    editingDisclaimer?: IDisclaimer,
    deleteDocumentID: number;
    showCloneProject: boolean;
    orderToDelete: IOrder | undefined;
    productToDelete: IProduct | undefined;
    productToPublish: IProduct | undefined;
    publishProductFlag: boolean;
    orderedDocument: IDocument | null;
    orderToShow: IOrder | null;
    pagesError: boolean;
    dividersError: string[];
    documentToDownload: IDocument | null;
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        openDocumentById: (id: string, redirect?: string) => {
            dispatch(openDocumentById(id, redirect));
        },
        deleteDocument: (id: number) => {
            dispatch(deleteDocument(id));
        },
        getAdminOrdersList: (startIndex: Number, listSize: Number, orderCategory: Number) => {
            dispatch(getAdminOrdersList(startIndex, listSize, orderCategory));
        },
        getOrderTypeCount: (status_id: number) => {
            dispatch(getOrderTypeCount(status_id))
        },
        getDocumentList: (userID: string) => {
            dispatch(getDocumentList(userID));
        },
        getAllProducts: () => {
            dispatch(getAllProducts());
        },
        getSeeds: () => {
            dispatch(getSeeds());
        },
        getSeedCategories: () => {
            dispatch(getSeedCategories());
        },
        getStatesList: () => {
            dispatch(getStatesList());
        },
        startLoading: () => {
            dispatch(startLoading());
        },
        stopLoading: () => {
            dispatch(stopLoading());
        },
        deleteOrder: (order: IOrder) => {
            dispatch(deleteOrder(order));
        },
        deleteProduct: (product: IProduct, type: string) => {
            dispatch(deleteProduct(product));
        },
        toggleProductPublish: (product: IProduct, published: boolean) => {
            dispatch(toggleProductPublish(product, published))
        },
        changeOrderStatus: (order: any, statusId: number) => {
            dispatch(changeOrderStatus(order, statusId));
        },
        getProductLogosList: () => {
          dispatch(getProductLogosList());
        },
        getProductIconsList: () => {
          dispatch(getProductIconsList());
        },
        saveProduct: (originalName: string,
            product: IProduct,
            imagesFormData?: FormData,
            logoFormData?: FormData) => {
            dispatch(saveProduct(originalName,
                product,
                imagesFormData,
                logoFormData));
        },
        saveSeedProduct: (seed: ISeedProductSubmit, isTogglingPublish: Boolean) => {
            dispatch(saveSeedProduct(seed, isTogglingPublish));
        },
        onDownload: (document: IDocument, dividers: IDivider[], disclaimers: IDisclaimer[], userData: IUserData, isPrintDownload: boolean) => {
          dispatch(downloadPdf(document, dividers, disclaimers, userData, isPrintDownload));
        },
        onCloneDocument: (document: IDocument, name: string, userID: string) => {
            dispatch(cloneDocument(document, name, userID));
        },
        placeOrder: (document: IDocument, user_id: string, user_email: string, username: string, comments: string, orderQuantitiesAddresses: IOrderQuantities_Addresses[]) => {
            dispatch(placeOrder(document, user_id, user_email, username, comments, orderQuantitiesAddresses));
        },
        hideOrderModal: () => {
            dispatch(hideOrderModal());
        },
    };
};

const mapStateToProps = (state: any) => {
    return {
        adminOrderTypeCount: state.adminOrderTypeCount,
        adminOrdersList: state.adminOrdersList,
        disclaimers: state.wizard.disclaimers,
        editor: state.editor,
        userDownloadList: state.userDownloadList,
        userData: state.user.data,
        orderCreated: state.orderCreated,
        orderStatuses: state.options.statuses,
        productList: state.productList,
        seedList: state.seedList,
        seedCategories: state.seedCategoryList,
        documentInProgress: state.document,
        documentList: state.documentList,
        productLogosList: state.productLogosList,
        productIconsList: state.productIconsList,
        statesList: state.statesList,
        createProductState: state.createProductState,
        dividers: state.wizard.dividers,
    };
};

const ordersPerPage = 10;
const initialOrderCategoryID = 2;

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class SuperUserPageView extends React.Component<ISuperUserPageProps, ISuperUserPageState> {
    constructor(props: any) {
        super(props);
        this.state = {
            currentTab: 0,
            showDeleteDocumentModal: false,
            showDeleteOrderModal: false,
            showDeleteProductModal: false,
            showTogglePublishModal: false,
            showDeleteEditingDocumentModal: false,
            showShippingInfoWarningModal: false,
            showShippingModal: false,
            showCloneProject: false,
            deleteDocumentID: -1,
            orderToDelete: undefined,
            productToDelete: undefined,
            productToPublish: undefined,
            publishProductFlag: false,
            orderedDocument: null,
            orderToShow: null,
            pagesError: false,
            disclaimers: [],
            dividersError: [],
            documentToDownload: null
        };

        // Bind methods
        this.onDownload = this.onDownload.bind(this)
        this.onDownloadPDFWithCropMarks = this.onDownloadPDFWithCropMarks.bind(this)
        this.onDeleteDocument = this.onDeleteDocument.bind(this)
        this.changeTab = this.changeTab.bind(this)
        this.changeStatus = this.changeStatus.bind(this)
        this.editDocument = this.editDocument.bind(this)
        this.closeModals = this.closeModals.bind(this)
        this.onCloneDocumentLocal = this.onCloneDocumentLocal.bind(this)
        this.onDeleteOrder = this.onDeleteOrder.bind(this)
        this.onDeleteProduct = this.onDeleteProduct.bind(this)
        this.onToggleProductPublish = this.onToggleProductPublish.bind(this)
        this.onOpenOrdersPreview = this.onOpenOrdersPreview.bind(this)
        this.onOpenCloneProject= this.onOpenCloneProject.bind(this)
        this.onOrderSubmit = this.onOrderSubmit.bind(this)
        this.onSaveDocument = this.onSaveDocument.bind(this)
        this.onShowShippingModal = this.onShowShippingModal.bind(this)
    }

    componentDidMount() {
        if (!this.props.adminOrdersList || (this.props.adminOrdersList.length == 0)) {
            this.props.getAdminOrdersList(0, ordersPerPage, initialOrderCategoryID);
        }
        if (!this.props.productList.length) {
            this.props.getAllProducts();
        }
        if (!this.props.seedList.length) {
            this.props.getSeeds();
        }
        if (!this.props.seedCategories.length) {
            this.props.getSeedCategories();
        }
        this.props.getStatesList();
        this.props.getDocumentList(this.props.userData.id);
        this.props.getProductLogosList();
        this.props.getProductIconsList();
        const tab = window.location.search.split('=')[1];
        if (tab) {
            this.setState({
                currentTab: +tab,
            });
        }
    }

    onDownload = (document: IDocument) => {
        this.setState({ documentToDownload: document });
    }

    onDownloadPDFWithCropMarks = (value: boolean) => {
        if (this.state.documentToDownload) {
            this.props.onDownload(this.state.documentToDownload, this.props.dividers, this.props.disclaimers, this.props.userData, value);
            this.setState({ documentToDownload: null });
        }
    }

    onDeleteDocument = (id: number) => {
        if ((this.props.documentInProgress != null) && (this.props.documentInProgress.id == id)) {
          this.setState({ showDeleteEditingDocumentModal: true });
          return;
        }

        this.setState({
            showDeleteDocumentModal: true,
            deleteDocumentID: id
        });
      }

    changeTab = (tab: number) => {
        this.setState({currentTab: tab});
    };

    changeStatus = (order: IOrder, statusId: number) => {
        this.props.changeOrderStatus(order, statusId);
    };

    editDocument = (documentId: number) => {
        this.props.openDocumentById(documentId, '/Editor');
    };

    closeModals = () => {
        this.setState({
            showDeleteDocumentModal: false,
            showDeleteOrderModal: false,
            showDeleteProductModal: false,
            showTogglePublishModal: false,
            showDeleteEditingDocumentModal: false,
            showShippingInfoWarningModal: false,
            showShippingModal: false,
            showCloneProject: false,
            editingDisclaimer: undefined,
            documentToDownload: null
        });
    };

    onCloneDocumentLocal = (document: IDocument | null, name: string) => {
        if (document !== null){
          this.props.onCloneDocument(document, name, this.props.userData.id)
        }
    }

    onDeleteOrder(order: IOrder) {
        this.setState({
            showDeleteOrderModal: true,
            orderToDelete: order,
        });
    }

    onDeleteProduct(product: IProduct) {
        this.setState({
            showDeleteProductModal: true,
            productToDelete: product,
        });
    }

    onToggleProductPublish(product: IProduct, published: boolean) {
        this.setState({
            showTogglePublishModal: true,
            productToPublish: product,
            publishProductFlag: published,
        });
    }

    onOpenOrdersPreview = (document: IDocument) => {
        this.setState({ showShippingInfoWarningModal: true, orderedDocument: document });
    };

    onOpenCloneProject = (document: IDocument) => {
        this.setState({ showCloneProject: true, orderedDocument: document});
      }

    onOrderSubmit = (document: IDocument, comments: string, orderQuantitiesAddresses: IOrderQuantities_Addresses[]) => {
        
        this.setState({ showShippingInfoWarningModal: false, orderedDocument: null});
        this.props.startLoading();
    
        DocumentService
          .saveDocument(document, this.props.userData.id)
          .then(() => {
            this.props.placeOrder(document, this.props.userData.id, this.props.userData.email, this.props.userData.username, comments, orderQuantitiesAddresses);
          })
          .catch(error => console.error(error));
    }

    onSaveDocument = (document: IDocument, userID: string) => {
        DocumentService.saveDocument(document, userID);
    }

    onShowShippingModal = (doc: IDocument, order: IOrder) => {
        this.setState({
          showShippingModal: true,
          orderedDocument: doc,
          orderToShow: order
        });
    }

    render() {

        const {
            adminOrderTypeCount,
            adminOrdersList,
            deleteDocument,
            deleteOrder,
            deleteProduct,
            documentInProgress,
            documentList,
            editor,
            orderCreated,
            orderStatuses,
            createProductState,
            userData,
            userDownloadList,
            saveProduct,
            productList,
            seedList,
            seedCategories,
            productLogosList,
            toggleProductPublish,
            statesList,
        } = this.props;

        return (
            <div className="root-container">
                <div className="header-container">
                    <img src={require('./img/Loveland_logo.svg')} className="loveland-logo"/>
                    <div className="header-container-right">
                        <DropdownMenu
                            title={<img src={require('../Admin/img/admin.svg')} className="admin-logo"/>}
                            options={[{
                                title: 'Logout',
                                onClick: () => window.location.pathname = '/auth/logout',
                            }]}
                        />
                    </div>
                </div>

                <div className="superUser-container">
                    <Tabs
                        tabsWrapperClassName="su-page-tab-wrapper"
                        tabsContainerClassName="su-page-tab-container"
                        tabBodyClassName="su-page-tab-body"
                        tabClassName="su-page-tab"
                        activeTabClassName="su-page-tab-active"
                        currentTab={this.state.currentTab}
                        onTabChanged={this.changeTab}
                    >
                        <Tab title="Review/Approve Orders">
                            <SuperUserOrdersTable
                                onDownloadPdf={this.onDownload}
                                adminOrderTypeCount={adminOrderTypeCount}
                                orders={adminOrdersList}
                                editDocument={doc => this.editDocument(doc.id)}
                                viewDocument={(doc: IDocument, order: IOrder) => this.onShowShippingModal(doc, order)}
                                statuses={orderStatuses}
                                changeStatus={this.changeStatus}
                                userDownloadList={userDownloadList}
                                onDeleteOrder={this.onDeleteOrder}
                                getOrderTypeCount={this.props.getOrderTypeCount}
                                getAdminOrdersList= {this.props.getAdminOrdersList}
                                ordersPerPage={ordersPerPage}
                                initialOrderCategoryID={initialOrderCategoryID}
                                disclaimers={this.props.disclaimers}
                                dividers={this.props.dividers}
                            />
                        </Tab>
                        <Tab title="Manage Products">
                            <ProductsTable
                                productList={productList}
                                onDeleteProduct={this.onDeleteProduct}
                                onToggleProductPublish={this.onToggleProductPublish}
                                saveProduct={saveProduct}
                                createProductState={createProductState}
                            />
                        </Tab>
                        <Tab title="Manage Seeds">
                            <SeedsTable
                                seedList={seedList}
                                seedCategories={seedCategories}
                                saveSeedProduct={saveSeedProduct}
                            />
                        </Tab>
                        <Tab title="Manage Projects">
                            <DocumentsTable
                                documents={documentList}
                                documentInProgress={documentInProgress}
                                editor={editor}
                                onEditDocument={this.editDocument}
                                onDeleteDocument={this.onDeleteDocument}
                                onDownload={this.onDownload}
                                onOpenOrdersPreview={this.onOpenOrdersPreview}
                                onOpenCloneProject={this.onOpenCloneProject}
                                userData={userData}
                                userDownloadList={userDownloadList}
                            />
                        </Tab>
                        <Tab title="Manage Images">
                          <ManageImages
                              productLogosList={productLogosList}
                            />
                        </Tab>
                        <Tab title="Manage Text">
                            <ManageText
                                products={productList}
                            />
                        </Tab>
                        <Tab title="Analytics">
                            <DivisionCostTable/>
                        </Tab>
                        <Tab title="Batch Downloads">
                            <BatchDownloads/>
                        </Tab>
                    </Tabs>
                </div>

                <PDFDownloadModal
                    show={ (this.state.documentToDownload != null) }
                    onClose={ this.closeModals }
                    onDownload={ this.onDownloadPDFWithCropMarks }
                />

                <DeleteConfirmModal
                    show={this.state.showDeleteOrderModal}
                    onClose={this.closeModals}
                    onSave={() => {
                        if (!!this.state.orderToDelete) {
                            deleteOrder(this.state.orderToDelete);
                        }
                        this.closeModals();
                    }}
                    title="Delete order?"
                />

                <DeleteConfirmModal
                    show={this.state.showDeleteProductModal}
                    onClose={this.closeModals}
                    onSave={() => {
                        if (!!this.state.productToDelete) {
                            deleteProduct(this.state.productToDelete);
                        }
                        this.closeModals();
                    }}
                    title="Delete product?"
                />


                <DeleteConfirmModal
                    show={this.state.showTogglePublishModal}
                    onClose={this.closeModals}
                    onSave={() => {
                        if (!!this.state.productToPublish) {
                            toggleProductPublish(this.state.productToPublish, this.state.publishProductFlag);
                        }
                        this.closeModals();
                    }}
                    title="Toggle publish state?"
                />

                <DeleteConfirmModal
                    show={this.state.showDeleteDocumentModal}
                    onClose={this.closeModals}
                    onSave={() => {
                        if (this.state.deleteDocumentID >= 0) {
                            deleteDocument(this.state.deleteDocumentID)
                        }
                        this.closeModals();
                    }}
                    title="Delete this document?"
                />
                
                <WarningModal
                    show={this.state.showDeleteEditingDocumentModal}
                    warningMessage="You can't delete the document being edited."
                    onClose={this.closeModals}
                />

                <ShippingModal
                    show={this.state.showShippingModal}
                    onClose={this.closeModals}
                    order={this.state.orderToShow}
                />

                <ShippingInfoWarningModal
                    document={this.state.orderedDocument}
                    userData={this.props.userData}
                    show={this.state.orderedDocument && this.state.showShippingInfoWarningModal}
                    onClose={() => this.setState({ showShippingInfoWarningModal: false,orderedDocument: null })}
                    onPlaceOrder={this.onOrderSubmit}
                    valid={true}
                    statesList={statesList}
                />
                
                <SuccessModal
                    show={orderCreated}
                    onClose={() => this.props.hideOrderModal()}
                    title={'Thank you for your order.'}
                    successMessage={<span>All orders will be received within 14 Business Days.</span>}
                />
                <CloneDocumentModal
                    show={this.state.showCloneProject}
                    onCloneDocument={(name: string) => {
                        this.closeModals()
                        this.onCloneDocumentLocal(this.state.orderedDocument, name)
                    }}
                    onClose={() => this.setState({ showCloneProject: false})}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/SuperUser/SuperUserPageView.tsx